<template>
  <div>
    <div v-if="availableChanges.length == 0">{{getCurrentStatus()}}</div>
    <select v-model="selected" @change="changeStatus()" v-if="availableChanges.length > 0">
      <option v-for="(status, index) in availableChanges" :key="index">{{ status.text }}</option>
    </select>
  </div>
</template>

<script>
import User from "@/models/User.js";
export default {
  props: ["currentStatus", "table", "statusRights", "statusNames", "id"],
  data() {
    return {
      user: new User(this.$session.get("user")),
      selected: null,
      availableChanges: []
    };
  },
  mounted() {
    this.initialize();
  },

  watch: {
    currentStatus() {
      this.initialize();
    }
  },

  methods: {
    initialize() {
      const indexOfCurrentStatus = this.statusNames
        .map(e => {
          return e.status;
        })
        .indexOf(this.currentStatus);
      if (indexOfCurrentStatus == -1) {
        return 0;
      }
      this.calculateAllowed();
      this.selected = this.statusNames[indexOfCurrentStatus]["text"];
    },

    getCurrentStatus() {
      const currentStatus = this.statusNames.find(e => {
        return e.status == this.currentStatus;
      });
      if(currentStatus == null){
        return "";
      }
      return currentStatus.text;
    },
    /**
     * check which status changes are allowed to make
     */
    calculateAllowed() {
      let allowed = [];
      if (this.user.type == 0 || this.user.type == 1) {
        this.statusNames.forEach(statusName => {
          allowed.push({
            text: statusName["text"],
            value: statusName["status"]
          });
        });
        this.availableChanges = allowed;
        return 0;
      }
      const userStatusRights = this.statusRights.filter(e => {
        return (
          e.company_id == this.user.company_id &&
          e.before == this.currentStatus &&
          e.user_type == this.user.type &&
          e.table_name == this.table
        );
      });
      this.statusNames.forEach(statusName => {
        const hasStatusRight = userStatusRights
          .map(e => {
            return e.after;
          })
          .indexOf(statusName.status);
        if (hasStatusRight != -1) {
          allowed.push({
            text: statusName.text,
            value: statusName.status
          });
        }
      });
      this.availableChanges = allowed;
    },

    /**
     * changes status to selected one
     */
    changeStatus() {
      const currentStatus = this.availableChanges.find(e => {
        return e.value == this.currentStatus;
      });
      const selectedChange = this.availableChanges.find(e => {
        return e.text == this.selected;
      });
      if (currentStatus.value > selectedChange.value) {
        if(!this.user.hasRights("TP_STATUSBACK")){
          alert(this.$t('status_change_to.no_right_to_lower'));
          return 0;
        }
      }
      if (currentStatus.value == selectedChange.value) {
        return 0;
      }
      const change = confirm(
        this.$t("status_change_to.do_you_really_want_to_change") +
          selectedChange.text +
          "?"
      );
      if (change != true) {
        this.selected = currentStatus.text;
        return 0;
      }
      const headers = {
        Authorization: "Bearer" + " " + this.$session.get("jwt")
      };
      const data = {
        status: selectedChange.value
      };
      this.$http
        .put(
          process.env.VUE_APP_ROOT_API + "/" + this.table + "/" + this.id,
          data,
          { headers }
        )
        .then(() => {
          this.calculateAllowed(selectedChange);
          this.$emit("statusChanged");
        });
    }
  }
};
</script>

<style>
</style>
